/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-06-08 21:45:33
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-06-29 20:07:45
 * @FilePath: /locationpms-pc/src/common/api/shop.ts
 * @Description:
 */
import { _post } from '@/common/request';
/**
 * 项目列表（带展位+线索锁档状态）
 * https://yapi.lanhanba.com/project/319/interface/api/41299
 */
export function getStopWithBoothClue(params) {
    return _post("/property/shops/shop_with_booth_clue", params, true);
}
